// resources/js/bootstrap/exitOnBack.js
import { router } from '@inertiajs/react';
import { route } from 'ziggy-js';

const EXIT_WINDOW_MS = 2000; // Ventana para el doble "atrás" en Home (poné 0 si preferís un solo click)

let lastBackAt = 0;

// course_id a usar cuando el back button manda "al dashboard" desde una
// pantalla que necesita pasar contexto propio (ej. para el AdScreen).
// Cada pantalla lo registra con setBackTarget() mientras está montada.
let backTarget = null;

export function setBackTarget(courseId) {
    backTarget = courseId;
}

function isHome() {
    return route().current('home') || route().current('dashboard');
}

/**
 * Anula la navegación de tipo "browser" (volver a la pantalla anterior)
 * en toda la app.
 *
 * Prioridad de decisión en cada "atrás":
 *  1. Si hay un backTarget registrado (ej. estamos saliendo de una
 *     lección) → SIEMPRE respetamos ese destino, sin importar en qué URL
 *     "aterrizó" el back real del navegador (puede coincidir con
 *     /dashboard por pura casualidad del historial, sin que eso implique
 *     que el usuario ya está "en home" para efectos de la lección).
 *  2. Si no hay backTarget y estamos en una pantalla "home" ('/' o
 *     /dashboard) → pedimos confirmación de salida.
 *  3. Cualquier otra pantalla → mandamos al dashboard simple.
 *
 * Se llama UNA sola vez al arrancar la SPA (ver App.jsx).
 */
export function initBackButtonHandler() {
    window.addEventListener('popstate', () => {
        // 1. Pantalla con destino propio registrado (ej. una lección)
        if (backTarget) {
            window.history.pushState(window.history.state, '', window.location.href);

            const target = route('dashboard', { ad: 1, course_id: backTarget });

            // Diferimos al próximo tick: Inertia también escucha este
            // mismo popstate y dispara su propia restauración/fetch
            // internamente. Si llamamos a router.visit() en el mismo
            // ciclo síncrono, competimos con esa restauración y una de
            // las dos peticiones termina cancelada (NS_BINDING_ABORTED).
            setTimeout(() => {
                router.visit(target, { replace: true });
            }, 0);
            return;
        }

        // 2. Pantallas "home": Welcome ('/') o Dashboard
        if (isHome()) {
            const now = Date.now();

            window.history.pushState(window.history.state, '', window.location.href);

            if (now - lastBackAt < EXIT_WINDOW_MS) {
                // Segunda pulsación a tiempo: intento de cierre real.
                // No es 100% consistente entre dispositivos/versiones de
                // Chrome — si no cierra, el usuario simplemente queda a
                // salvo en Home (nunca ve páginas ajenas como la de Google).
                window.close();
                return;
            }

            lastBackAt = now;
            alert('Pulse "back" again to exit.'); // cambiá el texto para confirmar que el build llegó
            return;
        }

        // 3. Cualquier otra pantalla sin backTarget propio
        window.history.pushState(window.history.state, '', window.location.href);
        setTimeout(() => {
            router.visit(route('dashboard'), { replace: true });
        }, 0);
    });
}